module.exports = __webpack_public_path__ + "static/media/cerdo.5dfd4c83.gif";